export const importfucntion = () =>{
    console.log("ami alada funciton import");
}

